// test601
(601 && 0);
